import {IEndPoint} from "/@lib@/commons/io/io.js";
import {REG} from "/@lib@/commons/registry.js";
import {BoxInputCode, ICurrentLang} from "/@back@/edit/wed/wedlets/box/boxInputCode.js";
import {IXAddr, XA} from "/@lib@/commons/xml/xAddr.js";
import {IParentWedlet, ISkAnnotListener, WEDLET, WedletFork} from "/@back@/edit/wed/wedlets/wedlet.js";
import {IXmlMsg} from "/@lib@/edit/ot/xmlHouse.js";
import {ISkAnnot} from "/@lib@/edit/schema/schemaAnnots.js";
import {IDiffAnnotValue} from "/@lib@/edit/schema/diff.js";
import Reg = REG.Reg;

/**
 * Affectation du bon langage au BoxCodeInput.
 */
class AdjustLangTypeWedlet extends WedletFork implements ISkAnnotListener {

	futureTask = 0;

	constructor(readonly widget: BoxInputCode, eltWedlet: IParentWedlet) {
		super(eltWedlet);
		if (!eltWedlet.isVirtual()) {
			//Valeur en cours de l'attribut à l'init du widget
			widget.setLangTypeDef(this.getMimeType());
		}
	}

	getMimeType(): string | null {
		const attr = XA.findDomLast(XA.append(this.mainWedlet.wedAnchor, 'mimeType'), this.mainWedlet.wedMgr.docHolder.getDocument());
		return attr instanceof Attr ? attr.value : null;
	}

	updateInDescendants(msg: IXmlMsg) {
		if (XA.last(msg.xa) === 'mimeType' || msg.xa[msg.xa.length - 2] === 'mimeType') {
			//Modification de l'attribut mimeType
			this.planSetLangTypeDef();
		}
	}

	protected planSetLangTypeDef() {
		if (this.futureTask === 0) {
			this.futureTask = window.requestIdleCallback((deadline: RequestIdleDeadline) => {
				this.futureTask = 0;
				this.widget.setLangTypeDef(this.getMimeType());
			});
		}
	}

	onAddedSkAnnot(annot: ISkAnnot, xaTarget: IXAddr): void {
		//console.log("onAddedSkAnnot", annot, xaTarget);
		if (WEDLET.diffLib?.isDiffAnnot(annot) && annot.diffSession === this.wedMgr.docHolder.getDiffSession()) {
			//console.log("annot::::::", annot);
			const v = (annot as IDiffAnnotValue).otherValue;
			if (v) this.widget.setDiffLangTypeDef(v);
		}
	}

	onRemovedSkAnnot(annot: ISkAnnot, xaTarget: IXAddr): void {
		if (WEDLET.diffLib?.isDiffAnnot(annot) && annot.diffSession === this.wedMgr.docHolder.getDiffSession()) {
			this.widget.setDiffLangTypeDef(null);
		}
	}

}

/** Fonction apelée au chargement de la lib par le WED. */
export function jslibAsyncInit(jsEndPoint: IEndPoint, elt: Element, wedReg: Reg<any>) {
	wedReg.registerSvc<ICurrentLang>("codePrim.currentLangFinder", 1, function currentLang(widget: BoxInputCode, tpl: Element) {
		//le widget BoxCodeInput est bindé sur le noeud texte, on s'accroche sur le wedlet de son élement parent.
		new AdjustLangTypeWedlet(widget, widget.wedlet.wedParent);
	});
}